import SearchInput from "../../shared-components/SearchInput";
import { connect } from "react-redux";
import {
  setUsers,
  setInitialUsersData,
} from "../../redux-state/features/users";
import _ from "lodash";

class SearchUsers extends SearchInput {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      searchQuery: "",
    };
  }

  handleSearchChange = (event) => {
    const searchQuery = event.target.value;
    this.setState({ searchQuery });
    this.handleSearch(searchQuery);
  };
  handleSearch = (searchQuery) => {
    // const { searchQuery } = this.state;
    const { initialData, setUsers } = this.props;

    if (searchQuery.trim()) {
      // Use lodash to filter the users array
      const filteredUsers = _.filter(initialData, (user) => {
        return (
          _.includes(_.toLower(user.full_name), _.toLower(searchQuery)) ||
          _.includes(_.toLower(user.email), _.toLower(searchQuery)) ||
          _.includes(_.toLower(user.user_type), _.toLower(searchQuery))
        );
      });

      // Update the Redux state with the filtered users
      setUsers(filteredUsers);
    } else {
      // If the search query is empty, reset to the initial users data
      setUsers(initialData);
    }
  };
  componentDidMount() {
    console.log(this.props.data);
  }
  render() {
    return super.render();
  }
}

const mapDispatchToProps = { setUsers, setInitialUsersData };
const mapStateToProps = (state) => ({
  data: state.UsersState.users,
  initialData: state.UsersState.initialUsersData,
});
export default connect(mapStateToProps, mapDispatchToProps)(SearchUsers);
